import { Controller } from "@hotwired/stimulus"

// Mobile menu for the site header (specs/005, decision D3): plain open/close
// toggle, deliberately minimal until the mobile maquette arrives. Pattern taken
// from Shalaya's header controller, without the scroll/transparency logic
// (the SPHERE5 header is a solid color on every page).
export default class extends Controller {
  static targets = ["hamburger", "mobileOverlay"]
  static classes = ["hamburgerOpen", "panelOpen"]

  toggleMobile() {
    const open = this.hamburgerTarget.classList.toggle(this.hamburgerOpenClass)
    this.mobileOverlayTarget.classList.toggle(this.panelOpenClass, open)
    this.hamburgerTarget.setAttribute("aria-expanded", open)
  }

  closeMobile() {
    this.hamburgerTarget.classList.remove(this.hamburgerOpenClass)
    this.mobileOverlayTarget.classList.remove(this.panelOpenClass)
    this.hamburgerTarget.setAttribute("aria-expanded", false)
  }
}
